module.exports = __webpack_public_path__ + "img/coins.1ba7073f.png";